import { createSlice } from '@reduxjs/toolkit';
export const errorReportSlice = createSlice({
  name: 'errorReport',
  initialState: {
    pending: false,
    screenshotFile: null,
    prefill: null
  },
  reducers: {
    setPendingErrorReport: (state, action) => {
      state.pending = true;
      state.screenshotFile = action.payload.screenshotFile || null;
      state.prefill = action.payload.prefill || null;
    },
    clearPendingErrorReport: state => {
      state.pending = false;
      state.screenshotFile = null;
      state.prefill = null;
    }
  }
});
export const {
  setPendingErrorReport,
  clearPendingErrorReport
} = errorReportSlice.actions;
export default errorReportSlice.reducer;